import { useCallback, useState } from 'react'

import { useMutation } from '@tanstack/react-query'
import { getRouteApi, useRouter } from '@tanstack/react-router'
import { Request } from 'commons/utils/request'
import { Toast } from 'ui/components'
import { useConfirmation } from 'ui/hooks'

import { handlerServerError } from '@orbit/errors'

const routeApi = getRouteApi('/_app/invoices/$id')

export const useDeleteFile = () => {
  const router = useRouter()
  const { id: invoiceSubmittalId } = routeApi.useParams()
  const [fileToDelete, setFile] = useState<{ fileId: number; fileName: string }>({ fileId: 0, fileName: '' })

  const { mutate: deleteInvoiceFile } = useMutation<void, Error, { invoiceSubmittalId: number; fileKeyIndex: number }>({
    mutationFn: (opts) => Request.delete(Request.urls.bank.invoiceSubmittalFileDelete, opts),
    onSuccess: async () => {
      Toast.successSmall('Invoice Submittal File was successfully deleted.')
      router.invalidate()
    },
    onError: (error) => handlerServerError(error)
  })

  const deleteInvoiceFileHandler = useCallback(() => {
    deleteInvoiceFile({
      invoiceSubmittalId: +invoiceSubmittalId,
      fileKeyIndex: fileToDelete.fileId
    })
  }, [deleteInvoiceFile, fileToDelete.fileId, invoiceSubmittalId])

  const { Confirmation: InvoiceFileDeleteConfirmation, open: openFilesDeleteConfirmation } = useConfirmation({
    message: `Are you sure you want to delete file "${fileToDelete.fileName}."`,
    onConfirm: deleteInvoiceFileHandler,
    confirmationButtonText: 'Delete',
    isConfirmationNegative: true
  })

  const setFileToDelete = (fileId: number, fileName: string) => {
    setFile({ fileId, fileName })
    openFilesDeleteConfirmation()
  }

  return { InvoiceFileDeleteConfirmation, setFileToDelete }
}
